'use strict';

var Promise = require('bluebird');
var loadMarketingTasks = require('./loadMarketingTasks');
var loadMarketingMustaches = require('./loadMarketingMustaches');
var renderMarketingTasks = require('./renderMarketingTasks');
var mappingModules = require('./mappingModules');

module.exports = function () {
  var isAdvancedReview = $('body').hasClass('review-advanced');
  var projectTaskUrl = $('.marketing-checklist').attr('data-project-url');
  var tasksPromise;
  var mustachesPromise;

  mappingModules();

  mustachesPromise = loadMarketingMustaches(isAdvancedReview)
    .catch(err => {
      window.Raven.captureMessage('Error loading marketingMustaches', {
        extra: {
          isAdvanced: isAdvancedReview,
          errorThrown: err,
          projectTaskUrl: projectTaskUrl
        }
      });
      throw err;
    });

  if ($('#dashboard').hasClass('generating-report')) {
    tasksPromise = new Promise(function (resolve, reject) {
      $('#dashboard').on('generationComplete', function () {
        resolve(loadMarketingTasks(projectTaskUrl));
      });
    });
  } else {
    tasksPromise = loadMarketingTasks(isAdvancedReview ? projectTaskUrl : null);
  }

  tasksPromise
    .catch(err => {
      window.Raven.captureMessage('Error loading marketingTasks', {
        extra: {
          isAdvanced: isAdvancedReview,
          errorThrown: err,
          projectTaskUrl: projectTaskUrl
        }
      });
      throw err;
    });

  Promise.all([
    mustachesPromise,
    tasksPromise
  ])
    .spread(function (mustaches, tasks) {
      renderMarketingTasks(mustaches, tasks, isAdvancedReview);
    })
    .catch(function (err) {
      return window.Raven.captureMessage(
        'Marketing checklist loading tasks error',
        {
          extra: {
            isAdvanced: isAdvancedReview,
            errorThrown: err,
            projectUrl: projectTaskUrl
          }
        });
    });
};
